import type { AttendanceClockAction } from './attendanceClock';

export const ATTENDANCE_CLOCK_UPDATED_EVENT = 'teamlio:attendance-clock-updated';

export interface AttendanceClockUpdatedDetail {
  action?: AttendanceClockAction;
  clockedIn?: boolean;
  userId?: string;
  sourceId?: string;
}

export const emitAttendanceClockUpdated = (
  detail: AttendanceClockUpdatedDetail = {},
): void => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent<AttendanceClockUpdatedDetail>(ATTENDANCE_CLOCK_UPDATED_EVENT, {
      detail,
    }),
  );
};

export const subscribeAttendanceClockUpdated = (
  listener: (detail: AttendanceClockUpdatedDetail) => void,
): (() => void) => {
  if (typeof window === 'undefined') return () => {};

  const handler = (event: Event) => {
    listener((event as CustomEvent<AttendanceClockUpdatedDetail>).detail || {});
  };

  window.addEventListener(ATTENDANCE_CLOCK_UPDATED_EVENT, handler);
  return () => window.removeEventListener(ATTENDANCE_CLOCK_UPDATED_EVENT, handler);
};
